import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20golden%20gradient%20background%20with%20flowing%20elegant%20curves%2C%20minimalist%20luxurious%20design%2C%20soft%20light%20beams%2C%20professional%20financial%20atmosphere%2C%20sophisticated%20composition&width=1800&height=600&seq=cta-bg-home&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 to-foreground-950/70"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-4">
          准备好开启你的财富增长之旅了吗？
        </h2>
        <p className="text-background-200/80 mb-10 max-w-xl mx-auto">
          立即注册磁力金牛，体验智能吸金引擎的强大力量。新用户享7天免费试用专业版全部功能。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/register"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-base transition-all duration-300 whitespace-nowrap"
          >
            免费注册，立即体验
            <i className="ri-rocket-line ml-2"></i>
          </Link>
          <Link
            to="/category/tutorial"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-50/30 rounded-lg text-base transition-all duration-300 whitespace-nowrap"
          >
            查看使用教程
            <i className="ri-book-open-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}